<template>
  <div>
    <config-hang
      class="message_hang_wraper"
      :fenGeXian="false"
      @click.native="messageBtnHandle(1)"
    >
      <img
        slot="config_hang_ele1"
        src="~assets/img/message/xinxi_xinxi.png"
        alt
      />
      <span slot="config_hang_ele2">公众消息</span>
      <img
        slot="config_hang_ele4"
        src="~assets/img/controlpublic/bai_youjiantou.png"
        alt
      />
    </config-hang>
    <config-hang
      class="message_hang_wraper"
      :fenGeXian="false"
      @click.native="messageBtnHandle(2)"
    >
      <img
        slot="config_hang_ele1"
        src="~assets/img/message/xinxi_haoyou.png"
        alt
      />
      <span slot="config_hang_ele2">好友消息</span>
      <img
        slot="config_hang_ele4"
        src="~assets/img/controlpublic/bai_youjiantou.png"
        alt
      />
    </config-hang>
    <config-hang
      class="message_hang_wraper"
      :fenGeXian="false"
      @click.native="messageBtnHandle(3)"
    >
      <img
        slot="config_hang_ele1"
        src="~assets/img/message/xinxi_baojing.png"
        alt
      />
      <span slot="config_hang_ele2">报警消息</span>
      <img
        slot="config_hang_ele4"
        src="~assets/img/controlpublic/bai_youjiantou.png"
        alt
      />
    </config-hang>
    <config-hang
      class="message_hang_wraper"
      :fenGeXian="false"
      @click.native="messageBtnHandle(4)"
    >
      <img
        slot="config_hang_ele1"
        src="~assets/img/message/xinxi_tishi.png"
        alt
      />
      <span slot="config_hang_ele2">提示消息</span>
      <img
        slot="config_hang_ele4"
        src="~assets/img/controlpublic/bai_youjiantou.png"
        alt
      />
    </config-hang>
  </div>
</template>

<script>
import configHang from 'components/common/config/config-hang'
import configTitleHang from 'components/common/config/config-title-hang'
export default {
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    messageBtnHandle(data) {
      console.log(data)
      this.$toast('暂未开放，敬请期待！')
    }
  },
  beforeCreate() {
    ///钩子函数：vue实例的挂载元素$el和数据对象data都为undefined，还未初始化。
  },
  created() {
    ///钩子函数: vue实例的数据对象data有了，$el还没有
    console.log('message被创建了')
  },
  beforeMount() {
    ///钩子函数: vue实例的$el和data都初始化了，但还是虚拟的dom节点，具体的data.filter还未替换。
  },
  activated() {
    console.log('message被激活了')
  },
  mounted() {
    //vue实例挂载完成，data.filter成功渲染  一般数据请求放在这里
    console.log('message被渲染成功了')
  },
  beforeDestroy() {
    ////组件销毁前调用
    console.log('message被销毁前')
  },
  destroyed() {
    console.log('message被销毁后')
  }
}
</script>

<style>
div > .message_hang_wraper {
  background-color: rgba(255, 255, 255, 0.6);
  margin: 10px 0px;
  border-radius: 5px;
}
div > div > .message_hang_wraper:active {
  background-color: rgba(255, 255, 255, 0.5);
}
div > .message_hang_wraper:hover {
  background-color: rgba(255, 255, 255, 0.7);
}
</style>
